import { render, staticRenderFns } from "./WedoParcelShop.vue?vue&type=template&id=307c6e32&scoped=true&"
import script from "./WedoParcelShop.vue?vue&type=script&lang=js&"
export * from "./WedoParcelShop.vue?vue&type=script&lang=js&"
import style0 from "./WedoParcelShop.vue?vue&type=style&index=0&id=307c6e32&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c6e32",
  null
  
)

export default component.exports